import React from 'react';
import { Row, Col } from 'antd';
import RevenueTrendChart from './RevenueTrendChart';
import { TopMerchants } from './TopMerchants';
import type {
  RevenueTrendData,
  TopMerchant,
} from '../../services/dashboardService';

interface AnalyticsSectionProps {
  revenueTrend: RevenueTrendData[];
  topMerchants: TopMerchant[];
  chartPeriod: 'today' | 'custom';
  rangeLabel: string;
  startDate: string;
  endDate: string;
  loading?: boolean;
}

export const AnalyticsSection: React.FC<AnalyticsSectionProps> = ({
  revenueTrend,
  topMerchants,
  chartPeriod,
  rangeLabel,
  startDate,
  endDate,
  loading = false,
}) => {
  return (
    <section className="dashboard-section dashboard-analytics-section">
      <Row className="dashboard-analytics-grid" gutter={[24, 24]}>
        <Col xs={24} lg={16} className="dashboard-analytics-col">
          <RevenueTrendChart
            data={revenueTrend}
            period={chartPeriod}
            loading={loading}
            variant="admin"
            rangeLabel={rangeLabel}
            startDate={startDate}
            endDate={endDate}
          />
        </Col>
        <Col xs={24} lg={8} className="dashboard-analytics-col">
          <TopMerchants
            data={topMerchants}
            loading={loading}
            startDate={startDate}
            endDate={endDate}
          />
        </Col>
      </Row>
    </section>
  );
};
